export const codes = ['SREPN01', 'SREPN02', 'SREPN03', 'SREPN04', 'SREPN05', 'SREPN06', 'SREPN07', 'SREPN08', 'SREPN09']
